import createDebug from "debug";
import { isEqual } from "lodash-es";
import { baseInfo } from "@kce2/common/core/baseinfo";
import { appendQuery } from "./router/navigator";
import type { RouteLocationNormalized, Router } from "vue-router";

const debug = createDebug("locationUtils");

export type Context = {
  region: string;
  namespace?: string;
};

export type QueryValue = {
  r?: string;
  ns?: string;
};

export function getQueryValueFromRoute(to: RouteLocationNormalized): QueryValue {
  return {
    r: (to.query.r as string) || undefined,
    ns: (to.query.ns as string) || undefined,
  };
}

export function getQueryValueFromContext(state: Context) {
  return {
    r: state.region || undefined,
    ns: state.namespace || undefined,
  };
}

export function appendCommonQuery(val: Context, route: RouteLocationNormalized) {
  const q = getQueryValueFromRoute(route);
  const newQ = getQueryValueFromContext(val);

  if (__DEV__) {
    debug("appendCommonQuery: origin", q, "new", newQ);
  }

  if (!isEqual(q, newQ)) {
    __DEV__ && debug("do append query", newQ);
    appendQuery(route, newQ);
  }
}

export function registryRouterGuard(router: Router) {
  router.beforeEach((to, source, next) => {
    const originQuery = getQueryValueFromRoute(to);
    const contextValue = baseInfo;
    const preferredQuery = getQueryValueFromContext(contextValue);

    if (__DEV__) {
      debug("from", source, "to", to);
      debug("origin query", originQuery, "preferred query", preferredQuery);
    }

    if (isEqual(originQuery, preferredQuery)) {
      if (__DEV__) {
        debug("source route and to route get the same query, pass through");
      }
      next();
      return;
    }

    next({
      name: to.name as any,
      hash: to.hash,
      path: to.path,
      params: to.params,
      query: {
        ...(to.query || {}),
        ...preferredQuery,
      },
    } as any);
  });
}
